class AdvisorChange {
}

class AdvisorModel {
}

class Fund {
}

class Fee {
}

class Composition {
}

class Top10 {
}

class FundGroup {
}

class Umbrella {
}

class Answer {
}

class Country {
}

class Credential {
}

class Custody {
}

class Custodyuniverse {
}

class Doc {
}

class Employee {
}

class InvestmentChoice {
}

class MetaQuestion {
}

class OpenOrder {
}

class Order {
}

class Profile {
}

class Question {
}

class RealOwner {
}

class Resp {
}

class Sell {
}

class Sum {
}

class User {
}

class Userinfo {
}

class Statement {
}

class Upload {
}

/*
 * Public API Surface of model-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AdvisorChange, AdvisorModel, Answer, Composition, Country, Credential, Custody, Custodyuniverse, Doc, Employee, Fee, Fund, FundGroup, InvestmentChoice, MetaQuestion, OpenOrder, Order, Profile, Question, RealOwner, Resp, Sell, Statement, Sum, Top10, Umbrella, Upload, User, Userinfo };
